module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-editor"
  }, [_c('section', {
    staticClass: "panel media-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('gallery-media-list-editor', {
    attrs: {
      "disciplines": _vm.disciplines,
      "disabled": _vm.submitting
    },
    model: {
      value: (_vm.secondaryMedia),
      callback: function($$v) {
        _vm.secondaryMedia = $$v
      },
      expression: "secondaryMedia"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "panel thumbnail-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-button"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setFeaturedMediaFromFile
    }
  }), _vm._v("\n                            Upload Image\n                        ")])]), _vm._v(" "), (!!_vm.featuredMedia.url) ? _c('div', [_c('image-cropper', {
    ref: "imageCropper",
    attrs: {
      "url": _vm.featuredMedia.url,
      "crop": _vm.featuredMediaCropPoints
    }
  })], 1) : _c('div', {
    staticClass: "empty-area"
  }, [_c('p', [_vm._v("No thumbnail to show")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "panel info-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Required'),
      expression: "'Required'"
    }]
  }, [_vm._v("Title *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Should be artistic (eg \"A Starry Night\"), not generic (eg \"Final Project\")",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Tell us anything you like about this project.",
      "cols": "50",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group categories"
  }, [_c('label', [_vm._v("Categories")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termId),
      expression: "termId"
    }],
    class: {
      'form-control': true, placeholder: !_vm.term
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.termId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                Term\n                            ")]), _vm._v(" "), _vm._l((_vm.termOptions), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                                " + _vm._s(term.name) + "\n                            ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathId),
      expression: "pathId"
    }],
    class: {
      'form-control': true, placeholder: !_vm.path, hidden: _vm.isTermFoundation(this.termId)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pathId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                Path\n                            ")]), _vm._v(" "), _vm._l((_vm.pathOptions), function(path) {
    return (path.id != 9200) ? _c('option', {
      domProps: {
        "value": path.id
      }
    }, [_vm._v("\n                                " + _vm._s(path.name) + "\n                            ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignmentId),
      expression: "assignmentId"
    }],
    class: {
      'form-control': true, placeholder: !_vm.assignment
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                Assignment\n                            ")]), _vm._v(" "), _vm._l((_vm.assignmentOptions), function(assignment) {
    return _c('option', {
      domProps: {
        "value": assignment.id
      }
    }, [_vm._v("\n                                " + _vm._s(assignment.name) + "\n                            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Software")]), _vm._v(" "), _c('software-select', {
    attrs: {
      "options": _vm.gallerySoftware,
      "canCreate": false,
      "placeholder": 'Select all software used in the making of this project.'
    },
    model: {
      value: (_vm.softwareUsed),
      callback: function($$v) {
        _vm.softwareUsed = $$v
      },
      expression: "softwareUsed"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group tags"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('tag-select', {
    attrs: {
      "search": _vm.searchTags,
      "canCreate": true,
      "placeholder": 'Short descriptive keywords describing the imagery, eg: sci-fi, warrior, sword, cat, ninja, castle, bird'
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dam-fields"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Industry Focus")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industryFocus),
      expression: "industryFocus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.industryFocus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.industryFocuses), function(focus) {
    return _c('option', {
      key: focus
    }, [_vm._v(_vm._s(focus))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group final-project"
  }, [_c('div', [_vm._v("Final Project")]), _vm._v(" "), _c('label', [_vm._v("Yes"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFinalProject),
      expression: "isFinalProject"
    }],
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.isFinalProject, "Yes")
    },
    on: {
      "__c": function($event) {
        _vm.isFinalProject = "Yes"
      }
    }
  }), _c('span', {
    staticClass: "toggle"
  })]), _vm._v(" "), _c('label', [_vm._v("No"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFinalProject),
      expression: "isFinalProject"
    }],
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.isFinalProject, "No")
    },
    on: {
      "__c": function($event) {
        _vm.isFinalProject = "No"
      }
    }
  }), _c('span', {
    staticClass: "toggle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Creation Date *")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "option": _vm.dateOptions,
      "date": _vm.creationDate
    },
    model: {
      value: (_vm.creationDate),
      callback: function($$v) {
        _vm.creationDate = $$v
      },
      expression: "creationDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Own Personal Artist Nickname / Alias")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moniker),
      expression: "moniker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "If you have an artist moniker you prefer to be credited with instead of your real name, put it here"
    },
    domProps: {
      "value": (_vm.moniker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.moniker = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Concept Credit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.conceptCredit),
      expression: "conceptCredit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Please be very sure to provide the correct name and spelling of the concept artist, if applicable"
    },
    domProps: {
      "value": (_vm.conceptCredit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.conceptCredit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group rookies-submission"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRookiesSubmission),
      expression: "isRookiesSubmission"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRookiesSubmission) ? _vm._i(_vm.isRookiesSubmission, null) > -1 : (_vm.isRookiesSubmission)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isRookiesSubmission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRookiesSubmission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRookiesSubmission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRookiesSubmission = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Tick this box if this project will be submitted to The Rookies")])])]), _vm._v(" "), (_vm.canEditHighlight) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Recruiter Visbility")]), _vm._v(" "), _c('div', {
    staticClass: "form-group recruiters"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.highlighted),
      expression: "highlighted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.highlighted) ? _vm._i(_vm.highlighted, null) > -1 : (_vm.highlighted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.highlighted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.highlighted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.highlighted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.highlighted = $$c
        }
      }
    }
  }), _vm._v("\n                                Visible to recruiters\n                            ")])])]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    staticClass: "panel submission-container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitGallery()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('div', [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitText
    }
  })]), _vm._v(" "), (!!_vm.submissionStatus) ? _c('div', {
    staticClass: "submission-feedback"
  }, [_c('div', {
    staticClass: "submission-status"
  }, [_vm._v("\n                            Status: "), _c('em', [_vm._v(_vm._s(_vm.submissionStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "submission-progress"
  }, [_c('div', {
    class: {
      'completed-bar': true, error: !!_vm.submissionError
    },
    style: ({
      width: (_vm.submissionProgress * 100) + '%'
    })
  })])]) : _vm._e()])])])]), _vm._v(" "), (!_vm.isNewGallery) ? _c('section', {
    staticClass: "panel delete-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.deleteGallery()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.deleting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deletionText),
      expression: "deletionText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type \"delete me\" to enable the button below"
    },
    domProps: {
      "value": (_vm.deletionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deletionText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit",
      "value": "Delete",
      "disabled": !_vm.canDelete
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v("\n                Media\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v("\n                Thumbnail\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                Details\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("\n                Submission\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n                Delete\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c5f01b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryEditor.vue
// module id = 1951
// module chunks = 2